import React from 'react';
import { Link } from 'react-router-dom';
import './CtasInferiores.scss';

const WHATSAPP_COTIZAR = 'https://wa.me/5492915061230?text=' + encodeURIComponent('Hola, quiero cotizar una obra');

const cards = [
	{
		icon: 'fa-id-badge',
		title: '¿Sos profesional?',
		text: 'Registrate y accedé a beneficios exclusivos para arquitectos, maestros y técnicos.',
		ctaText: 'Conocer más',
		to: '/profesionales',
		external: false,
	},
	{
		icon: 'fa-handshake-o',
		title: '¿Sos proveedor?',
		text: 'Sumate a nuestra red de proveedores y trabajemos juntos en cada obra.',
		ctaText: 'Quiero ser proveedor',
		to: '/proveedores',
		external: false,
	},
	{
		icon: 'fa-map-marker',
		title: 'Encontrá tu sucursal',
		text: '5 sucursales en la zona para que retires o consultes en persona.',
		ctaText: 'Ver sucursales',
		to: '/sucursales',
		external: false,
	},
	{
		icon: 'fa-whatsapp',
		title: '¿Necesitás cotizar una obra?',
		text: 'Hablemos por WhatsApp y te asesoramos con materiales y precios.',
		ctaText: 'Cotizar por WhatsApp',
		to: WHATSAPP_COTIZAR,
		external: true,
	},
];

const CardCta = ({ card }) => {
	const inner = (
		<>
			<div className="ctas-inferiores__icon"><i className={`fa ${card.icon}`} aria-hidden="true"></i></div>
			<h3 className="ctas-inferiores__title">{card.title}</h3>
			<p className="ctas-inferiores__text">{card.text}</p>
			<span className="ctas-inferiores__link">
				{card.ctaText} <i className="fa fa-arrow-right" aria-hidden="true"></i>
			</span>
		</>
	);
	if (card.external) {
		return (
			<a href={card.to} target="_blank" rel="noopener noreferrer" className="ctas-inferiores__card">
				{inner}
			</a>
		);
	}
	return (
		<Link to={card.to} className="ctas-inferiores__card">
			{inner}
		</Link>
	);
};

const CtasInferiores = () => (
	<section className="ctas-inferiores">
		<div className="container">
			<h2 className="ctas-inferiores__heading">Estamos para ayudarte</h2>
			<div className="row">
				{cards.map((card) => (
					<div key={card.title} className="col-12 col-sm-6 col-lg-3 ctas-inferiores__col">
						<CardCta card={card} />
					</div>
				))}
			</div>
		</div>
	</section>
);

export default CtasInferiores;
